import FileInput from 'components/inputs/FileInput';

export default function AddImageMobile({ handleSelectFile, openCam }) {
  return (
    <div className="flex flex-col items-center justify-center px-4 bg-lt-beige h-[400px]">
      <p className="text-center mb-4">
        Choose an image from your device or take a photo
      </p>

      <FileInput
        label="Choose Image"
        onChange={handleSelectFile}
        id="choose-image-file"
      />
    </div>
  );
}
